"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.ragStatus.pending': 'Pending',
    'knowledge.ragStatus.processing': 'Processing',
    'knowledge.ragStatus.completed': 'Completed',
    'knowledge.ragStatus.failed': 'Failed',
    'knowledge.ragStatus.not_indexed': 'Not Applicable',
};
